/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconHandFingerRight = createReactComponent("outline", "hand-finger-right", "IconHandFingerRight", [["path", { "d": "M12 8h8.5a1.5 1.5 0 0 1 0 3h-7.5", "key": "svg-0" }], ["path", { "d": "M13.5 11h2a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-1" }], ["path", { "d": "M14.5 14a1.5 1.5 0 0 1 0 3h-1.5", "key": "svg-2" }], ["path", { "d": "M13.5 17a1.5 1.5 0 1 1 0 3h-4.5a6 6 0 0 1 -6 -6v-2v.208a6 6 0 0 1 2.7 -5.012l.3 -.196q .718 -.468 5.728 -3.286a1.5 1.5 0 0 1 2.022 .536c.44 .734 .325 1.674 -.28 2.28l-1.47 1.47", "key": "svg-3" }]]);

export { IconHandFingerRight as default };
//# sourceMappingURL=IconHandFingerRight.mjs.map
